export const artStyles = [
  {
    id: "pattachitra",
    name: "Pattachitra",
    thumbnail: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&h=300&fit=crop&crop=center",
    briefDescription: "Traditional Indian art with bold outlines and vibrant colors",
    description: "Pattachitra is a traditional Indian art form from Odisha, characterized by bold outlines, vibrant colors, and intricate details. These paintings are typically done on cloth or dried palm leaves, featuring mythological stories, religious themes, and traditional motifs. The style is known for its distinctive linework, flat perspective, and rich cultural heritage.",
    videoUrl: "/videos/pattachitra-intro.mp4",
    characteristics: ["Bold outlines", "Vibrant colors", "Traditional motifs", "Flat perspective", "Intricate details"],
    famousArtists: ["Traditional Pattachitra artists", "Odisha artisans", "Cultural heritage artists"],
    yearRange: "17th-18th century",
    kidFriendlyDescription: "Pattachitra is like painting stories from ancient India! Artists use bold lines and bright colors to tell traditional tales, just like a beautiful picture book from long ago!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/pattachitra/transform"
  },
  {
    id: "cubism",
    name: "Cubism",
    thumbnail: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&h=300&fit=crop&crop=center",
    briefDescription: "Geometric shapes showing multiple perspectives at once",
    description: "Cubism is like looking at something from many different angles at once! Artists from the early 1900s broke objects into geometric shapes and showed different sides of things at the same time. It's like taking a picture of something from the front, side, and top all at once! Cubism makes you think about how we see the world around us.",
    videoUrl: "/videos/cubism-intro.mp4",
    characteristics: ["Geometric shapes", "Multiple perspectives", "Abstract forms", "Different angles"],
    famousArtists: ["Pablo Picasso", "Georges Braque", "Juan Gris"],
    yearRange: "1907-1914",
    kidFriendlyDescription: "Cubism is like looking at something from every angle at once! Artists broke things into shapes and showed different sides all together!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/cubism/transform"
  },
  {
    id: "impressionism",
    name: "Impressionism",
    thumbnail: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&h=300&fit=crop&crop=center",
    briefDescription: "Painting with light and visible brushstrokes",
    description: "Impressionism is like painting with sunshine! Artists from the 1800s wanted to capture how light changes everything we see. They painted outdoors to catch the real colors of nature and used quick, visible brushstrokes to show movement. Impressionist paintings are like looking at the world through happy, colorful glasses!",
    videoUrl: "/videos/impressionism-intro.mp4",
    characteristics: ["Light effects", "Visible brushstrokes", "Outdoor scenes", "Bright colors"],
    famousArtists: ["Claude Monet", "Pierre-Auguste Renoir", "Camille Pissarro"],
    yearRange: "1860s-1880s",
    kidFriendlyDescription: "Impressionism is like painting with pure sunshine! Artists wanted to show how light makes everything beautiful and colorful, like a perfect sunny day!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/impressionism/transform"
  },
  {
    id: "surrealism",
    name: "Surrealism",
    thumbnail: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&h=300&fit=crop&crop=center",
    briefDescription: "Dream-like art with impossible combinations",
    description: "Surrealism is like painting your wildest dreams! Artists wanted to show the strange and wonderful world of imagination, where anything can happen. They combined real things in impossible ways, like a clock melting or a fish flying through the sky. Surrealist art is like stepping into a dream where the rules of reality don't apply!",
    videoUrl: "/videos/surrealism-intro.mp4",
    characteristics: ["Dream-like scenes", "Impossible combinations", "Creative imagination", "Strange ideas"],
    famousArtists: ["Salvador Dalí", "René Magritte", "Yves Tanguy"],
    yearRange: "1920s-1950s",
    kidFriendlyDescription: "Surrealism is like painting your craziest dreams! Artists showed impossible things happening, like clocks melting or fish flying in the sky!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/surrealism/transform"
  },
  {
    id: "artnouveau",
    name: "Art Nouveau",
    thumbnail: "/styles/artnouveau-thumb.jpg",
    description: "Art Nouveau is like painting with flowing, beautiful lines! Artists from the late 1800s and early 1900s created elegant, decorative art with graceful curves and natural patterns. They used flowing lines, flowers, and organic shapes to make everything look elegant and harmonious. Art Nouveau is like turning everyday things into beautiful, flowing works of art!",
    videoUrl: "/videos/artnouveau-intro.mp4",
    characteristics: ["Flowing lines", "Organic motifs", "Decorative elements", "Elegant curves", "Natural patterns"],
    famousArtists: ["Alphonse Mucha", "Gustav Klimt", "Aubrey Beardsley"],
    yearRange: "1890s-1910s",
    kidFriendlyDescription: "Art Nouveau is like painting with beautiful, flowing lines! Artists made everything look elegant with graceful curves and natural patterns!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/artnouveau/transform"
  },
  {
    id: "popart",
    name: "Pop Art",
    thumbnail: "/styles/popart-thumb.jpg",
    description: "Pop Art is like turning everyday things into bold, colorful art! Artists from the 1950s and 60s took inspiration from popular culture, comic books, and advertising. They used bright colors, bold outlines, and simple shapes to make art that was fun and accessible to everyone. Pop Art celebrates the ordinary and makes it extraordinary!",
    videoUrl: "/videos/popart-intro.mp4",
    characteristics: ["Bold colors", "Graphic elements", "Commercial style", "Simple shapes", "High contrast"],
    famousArtists: ["Andy Warhol", "Roy Lichtenstein", "Keith Haring"],
    yearRange: "1950s-1970s",
    kidFriendlyDescription: "Pop Art is like making everyday things into bold, colorful art! Artists used bright colors and simple shapes to make fun, exciting pictures!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/popart/transform"
  },
  {
    id: "renaissance",
    name: "Renaissance",
    thumbnail: "/styles/renaissance-thumb.jpg",
    description: "Renaissance art is like painting with perfect beauty and harmony! Artists from the 14th to 17th centuries created incredibly realistic paintings with balanced compositions, perfect perspective, and lifelike figures. They used techniques like chiaroscuro (light and shadow) to make everything look three-dimensional and natural. Renaissance art celebrates human beauty, nature, and the harmony of the world around us!",
    videoUrl: "/videos/renaissance-intro.mp4",
    characteristics: ["Realistic representation", "Balanced composition", "Perfect perspective", "Lifelike figures", "Chiaroscuro lighting"],
    famousArtists: ["Leonardo da Vinci", "Raphael", "Michelangelo", "Sandro Botticelli"],
    yearRange: "14th-17th century",
    kidFriendlyDescription: "Renaissance art is like painting with perfect beauty! Artists created incredibly realistic paintings with balanced compositions and lifelike figures!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/renaissance/transform"
  },
  {
    id: "warli",
    name: "Warli",
    thumbnail: "/styles/warli-thumb.jpg",
    description: "Warli art is like telling stories with simple shapes! This ancient tribal art from Maharashtra, India uses stick figures, geometric patterns, and minimalist designs to create beautiful compositions. Artists paint with white pigment on brown backgrounds, showing daily life, celebrations, and nature in a unique tribal style. Warli art is like drawing with the purest, simplest forms!",
    videoUrl: "/videos/warli-intro.mp4",
    characteristics: ["Minimalist style", "Stick figures", "Geometric patterns", "Monochromatic", "Tribal art"],
    famousArtists: ["Traditional Warli artists", "Maharashtra tribal artists", "Indigenous artists"],
    yearRange: "Ancient to present",
    kidFriendlyDescription: "Warli art is like telling stories with simple shapes! Artists use stick figures and geometric patterns to create beautiful tribal art!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/warli/transform"
  },
  {
    id: "fauvism",
    name: "Fauvism",
    thumbnail: "/styles/fauvism-thumb.jpg",
    description: "Fauvism is like painting with wild, untamed colors! This bold art movement from the early 1900s uses pure, vibrant colors that don't look realistic at all. Artists like Matisse created simplified forms with bold outlines, using colors that express emotion rather than reality. Fauvism is like painting with the most exciting, energetic colors you can imagine!",
    videoUrl: "/videos/fauvism-intro.mp4",
    characteristics: ["Wild colors", "Simplified forms", "Bold outlines", "Non-naturalistic", "High contrast"],
    famousArtists: ["Henri Matisse", "André Derain", "Maurice de Vlaminck", "Raoul Dufy"],
    yearRange: "1904-1910",
    kidFriendlyDescription: "Fauvism is like painting with wild, untamed colors! Artists use pure, vibrant colors that express emotion rather than reality!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/fauvism/transform"
  },
  {
    id: "pointillism",
    name: "Pointillism",
    thumbnail: "/styles/pointillism-thumb.jpg",
    description: "Pointillism is like painting with thousands of tiny dots! This fascinating art technique uses small dots of pure color that blend together when you look at them from a distance. Artists like Seurat created entire paintings using only dots, creating beautiful optical effects. Pointillism is like painting with the tiniest brush strokes imaginable!",
    videoUrl: "/videos/pointillism-intro.mp4",
    characteristics: ["Small dots", "Pure colors", "Optical blending", "No outlines", "Bright hues"],
    famousArtists: ["Georges Seurat", "Paul Signac", "Henri-Edmond Cross", "Maximilien Luce"],
    yearRange: "1886-1900",
    kidFriendlyDescription: "Pointillism is like painting with thousands of tiny dots! Artists use small dots of pure color that blend together when you look from a distance!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/pointillism/transform"
  },
  {
    id: "madhubani",
    name: "Madhubani",
    thumbnail: "/styles/madhubani-thumb.jpg",
    description: "Madhubani is like painting with the most beautiful patterns! This traditional Indian folk art uses intricate lines, flat vibrant colors, and geometric borders to tell stories. Artists fill every space with fish, birds, flowers, and figures with large expressive eyes. Madhubani is like creating a magical world with the most detailed and colorful patterns!",
    videoUrl: "/videos/madhubani-intro.mp4",
    characteristics: ["Intricate lines", "Flat vibrant colors", "Geometric borders", "Large eyes", "Ornate clothing"],
    famousArtists: ["Traditional Madhubani artists", "Bihar folk artists", "Mithila artists"],
    yearRange: "Ancient to present",
    kidFriendlyDescription: "Madhubani is like painting with the most beautiful patterns! Artists use intricate lines and vibrant colors to create magical worlds!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/madhubani/transform"
  },
  {
    id: "baroque",
    name: "Baroque",
    thumbnail: "/styles/baroque-thumb.jpg",
    description: "Baroque art is full of drama and light! This style uses strong contrasts (tenebrism), dynamic movement, and rich details to make scenes feel alive. Artists used deep perspective and dramatic lighting to guide your eyes across expressive figures and textured clothing.",
    videoUrl: "/videos/baroque-intro.mp4",
    characteristics: ["Tenebrism", "Dynamic movement", "Rich detail", "Expressive figures", "Dramatic lighting"],
    famousArtists: ["Caravaggio", "Peter Paul Rubens", "Rembrandt"],
    yearRange: "17th century",
    kidFriendlyDescription: "Baroque is like turning on a spotlight in a dark room! Bright highlights and deep shadows make the scene feel exciting and full of movement!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/baroque/transform"
  },
  {
    id: "expressionism",
    name: "Expressionism",
    thumbnail: "/styles/expressionism-thumb.jpg",
    description: "Expressionism is like painting with pure emotion! This bold art style uses exaggerated shapes and intense colors to express feelings rather than showing reality. Artists distort forms, use angular lines, and create intense expressions to convey powerful emotions. Expressionism is like painting with your heart instead of your eyes!",
    videoUrl: "/videos/expressionism-intro.mp4",
    characteristics: ["Distorted forms", "Intense expressions", "Angular lines", "Bold symbolic colors", "Energetic strokes", "Saturated colors"],
    famousArtists: ["Edvard Munch", "Ernst Ludwig Kirchner", "Emil Nolde", "Wassily Kandinsky"],
    yearRange: "Early 20th century",
    kidFriendlyDescription: "Expressionism is like painting with pure emotion! Artists use exaggerated shapes and intense colors to show how they feel inside!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/expressionism/transform"
  },
  {
    id: "gond",
    name: "Gond",
    thumbnail: "/styles/gond-thumb.jpg",
    description: "Gond art is a beautiful tribal art form from central India! This traditional style features stylized animals and humans with elongated forms filled with repetitive dots, dashes, and lines. The art is filled with nature motifs and uses bright earthy colors like reds, yellows, greens, and blues with bold black outlines. Gond art tells stories through patterns and symbols!",
    videoUrl: "/videos/gond-intro.mp4",
    characteristics: ["Stylized forms", "Repetitive patterns", "Nature motifs", "Bright colors", "Black outlines", "Elongated shapes"],
    famousArtists: ["Jangarh Singh Shyam", "Bhajju Shyam", "Durga Bai", "Traditional Gond artists"],
    yearRange: "Traditional to present",
    kidFriendlyDescription: "Gond art is like painting with nature's patterns! Artists use dots, dashes, and lines to create beautiful stylized animals and people with bright colors!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/gond/transform"
  },
  {
    id: "ukiyoe",
    name: "Ukiyo-e",
    thumbnail: "/styles/ukiyoe-thumb.jpg",
    description: "Ukiyo-e is a traditional Japanese woodblock print style that captures the beauty of everyday life! This elegant art form features flat colors, graceful outlines, and distinctive wave-like patterns in water and clouds. Artists use muted reds, indigo blues, and pale creams with delicate textures and fine lines. Ukiyo-e is like creating beautiful prints that tell stories of Japan's floating world!",
    videoUrl: "/videos/ukiyoe-intro.mp4",
    characteristics: ["Flat colors", "Graceful outlines", "Wave-like patterns", "Muted reds and indigo blues", "Delicate textures", "Fine lines"],
    famousArtists: ["Katsushika Hokusai", "Utagawa Hiroshige", "Kitagawa Utamaro"],
    yearRange: "17th-19th century",
    kidFriendlyDescription: "Ukiyo-e is like making beautiful Japanese woodblock prints! Artists use flat colors and graceful lines to create peaceful, elegant scenes!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/ukiyoe/transform"
  },
  {
    id: "mughalminiature",
    name: "Mughal Miniature",
    thumbnail: "/styles/mughal-miniature-thumb.jpg",
    description: "Mughal Miniature is a traditional Indian painting style with fine detailing and ornate elements! This elegant art form features flat perspective, elaborate costumes, ornate floral borders, and soft pastel colors with gold highlights. Artists emphasize facial expressions and delicate hands, creating rich cultural and historical scenes. Mughal Miniature is like painting with the most delicate brush and precious materials!",
    videoUrl: "/videos/mughal-miniature-intro.mp4",
    characteristics: ["Fine detailing", "Flat perspective", "Elaborate costumes", "Ornate borders", "Soft pastels", "Gold highlights", "Facial expressions", "Delicate hands"],
    famousArtists: ["Bichitr", "Abu'l Hasan", "Govardhan", "Manohar", "Basawan", "Daswanth"],
    yearRange: "16th-19th century",
    kidFriendlyDescription: "Mughal Miniature is like painting with the most delicate brush! Artists use fine details, soft colors, and gold to create beautiful scenes from long ago!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/mughal-miniature/transform"
  },
  {
    id: "sumie",
    name: "Sumi-e",
    thumbnail: "/styles/sumie-thumb.jpg",
    description: "Sumi-e is a minimalist Japanese ink wash painting style that captures the essence of subjects with simple, fluid strokes! This elegant art form uses soft gradients, sparse brushwork, and open space to suggest form rather than showing every detail. Artists work with black ink on white paper, creating beautiful compositions that emphasize simplicity and harmony. Sumi-e is like painting with the purest form of expression!",
    videoUrl: "/videos/sumie-intro.mp4",
    characteristics: ["Minimalist approach", "Soft gradients", "Sparse brushwork", "Open space", "Simple fluid strokes", "Ink wash technique"],
    famousArtists: ["Sesshū Tōyō", "Hasegawa Tōhaku", "Soga Shōhaku"],
    yearRange: "14th-19th century",
    kidFriendlyDescription: "Sumi-e is like painting with the simplest, most beautiful strokes! Artists use soft ink washes and open space to create peaceful, elegant pictures!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/sumie/transform"
  },
  {
    id: "chineseink",
    name: "Chinese Ink Painting",
    thumbnail: "/styles/chineseink-thumb.jpg",
    description: "Chinese Ink Painting is a traditional art form that uses flowing ink washes and calligraphic brushwork to create beautiful, expressive artworks! This ancient technique focuses on the harmony between ink and paper, using soft gradients and elegant negative space to suggest form and atmosphere. Artists work with a monochrome palette, creating depth through varying tones of black, grey, and subtle washes. Chinese Ink Painting is like writing poetry with a brush!",
    videoUrl: "/videos/chineseink-intro.mp4",
    characteristics: ["Flowing ink washes", "Soft gradients", "Calligraphic brushwork", "Monochrome palette", "Elegant negative space", "Atmospheric depth"],
    famousArtists: ["Qi Baishi", "Xu Beihong", "Wu Guanzhong"],
    yearRange: "Ancient to present",
    kidFriendlyDescription: "Chinese Ink Painting is like writing beautiful poetry with a brush! Artists use flowing ink washes and elegant brushstrokes to create peaceful, expressive pictures!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/chineseink/transform"
  },
  {
    id: "mexicanmuralism",
    name: "Mexican Muralism",
    thumbnail: "/styles/mexicanmuralism-thumb.jpg",
    description: "Mexican Muralism is a powerful art movement that tells stories through bold, monumental paintings! Inspired by artists like Diego Rivera, this style features large human figures in dramatic poses that tell social and historical stories. The art is filled with rich, vibrant colors — bright reds, yellows, blues, and earthy tones — and intricate details showing community life, nature, and industry. Mexican Muralism is like painting a grand story on a huge wall!",
    videoUrl: "/videos/mexicanmuralism-intro.mp4",
    characteristics: ["Large bold human figures", "Dramatic dynamic poses", "Rich saturated colors", "Strong confident outlines", "Layered scenes", "Monumental scale"],
    famousArtists: ["Diego Rivera", "José Clemente Orozco", "David Alfaro Siqueiros"],
    yearRange: "1920s-1950s",
    kidFriendlyDescription: "Mexican Muralism is like painting a grand story on a huge wall! Artists use bold figures and bright colors to tell exciting stories about people and communities!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/mexicanmuralism/transform"
  },
  {
    id: "africantribal",
    name: "African Tribal Art",
    thumbnail: "/styles/africantribal-thumb.jpg",
    description: "African Tribal Art is a beautiful traditional art form that tells stories through bold geometric patterns and earthy colors! This ancient style uses ochres, browns, blacks, and deep reds to create striking designs inspired by traditional symbols. Artists stylize human and animal figures with elongated forms and simplified features, creating rhythmic patterns that tell cultural stories. African Tribal Art is like painting the wisdom of ancient traditions!",
    videoUrl: "/videos/africantribal-intro.mp4",
    characteristics: ["Earthy tones", "Bold geometric patterns", "Elongated forms", "Simplified features", "Rhythmic repetition", "Cultural storytelling"],
    famousArtists: ["Traditional African artists", "Tribal artisans", "Cultural heritage artists"],
    yearRange: "Ancient to present",
    kidFriendlyDescription: "African Tribal Art is like painting the wisdom of ancient traditions! Artists use bold patterns and earthy colors to tell stories from long ago!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/africantribal/transform"
  },
  {
    id: "futurism",
    name: "Futurism",
    thumbnail: "/styles/futurism-thumb.jpg",
    description: "Futurism is an exciting art movement that celebrates speed, technology, and the modern world! This dynamic style uses motion blur, speed lines, and fragmented angular shapes to show energy and movement. The art is filled with bright metallic colors — silvers, golds, electric blues, and reds — with reflective highlights that make everything look fast and modern. Futurism captures multiple perspectives in the same frame to show how time moves, creating an energetic, almost explosive feeling!",
    videoUrl: "/videos/futurism-intro.mp4",
    characteristics: ["Motion blur and speed lines", "Fragmented angular shapes", "Bright metallic colors", "Multiple perspectives", "Energetic composition", "Industrial aesthetic"],
    famousArtists: ["Umberto Boccioni", "Giacomo Balla", "Carlo Carrà", "Gino Severini"],
    yearRange: "1909-1944",
    kidFriendlyDescription: "Futurism is like painting with pure speed and energy! Artists use motion blur and bright metallic colors to show how fast and exciting the modern world is!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/futurism/transform"
  }
,
  {
    id: "byzantine",
    name: "Byzantine Art",
    thumbnail: "/styles/byzantine-thumb.jpg",
    description: "Byzantine Art is a magnificent ancient religious art style that creates spiritual and symbolic masterpieces! This style features flat, frontal figures with rich gold backgrounds and strong outlines that make everything look divine and otherworldly. Faces are solemn and dignified, with large, almond-shaped eyes that seem to gaze into your soul. Byzantine Art is like painting with pure gold and divine light!",
    videoUrl: "/videos/byzantine-intro.mp4",
    characteristics: ["Flat frontal figures","Rich gold backgrounds","Strong outlines","Solemn faces","Large almond-shaped eyes","Spiritual focus"],
    famousArtists: ["Unknown Byzantine artists","Icon painters","Religious artisans"],
    yearRange: "330-1453 CE",
    kidFriendlyDescription: "Byzantine Art is like painting with pure gold and divine light! Artists use flat figures and golden backgrounds to create beautiful religious pictures!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/byzantine/transform"
  },
  {
    id: "artdeco",
    name: "Art Deco",
    thumbnail: "/styles/artdeco-thumb.jpg",
    description: "Art Deco is a glamorous and elegant art style that celebrates luxury and modernity! This sophisticated style uses geometric shapes, symmetrical patterns, and streamlined forms to create a sense of elegance and progress. The art is filled with metallic tones, rich colors, and clean lines that make everything look sleek and modern. Art Deco is like painting with pure sophistication and style!",
    videoUrl: "/videos/artdeco-intro.mp4",
    characteristics: ["Geometric shapes","Symmetrical patterns","Streamlined forms","Metallic tones","Rich colors","Clean lines"],
    famousArtists: ["Tamara de Lempicka","Erté","Jean Dupas"],
    yearRange: "1920s-1940s",
    kidFriendlyDescription: "Art Deco is like painting with pure sophistication and style! Artists use geometric shapes and metallic colors to create elegant, modern pictures!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/artdeco/transform"
  },
  {
    id: "rococo",
    name: "Rococo",
    thumbnail: "/styles/rococo-thumb.jpg",
    description: "Rococo is a delightful and playful art style that celebrates beauty and grace! This charming style uses soft pastel colors, intricate decorative details, and playful, graceful forms to create a lighthearted and elegant atmosphere. The art is filled with ornate patterns and flowing curves that make everything feel like a beautiful dream. Rococo is like painting with pure joy and elegance!",
    videoUrl: "/videos/rococo-intro.mp4",
    characteristics: ["Soft pastel colors","Intricate decorative details","Playful graceful forms","Ornate patterns","Flowing curves","Lighthearted atmosphere"],
    famousArtists: ["Jean-Honoré Fragonard","François Boucher","Antoine Watteau"],
    yearRange: "1730s-1780s",
    kidFriendlyDescription: "Rococo is like painting with pure joy and elegance! Artists use soft pastels and flowing curves to create beautiful, dreamy pictures!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/rococo/transform"
  },
  {
    id: "minimalism",
    name: "Minimalism",
    thumbnail: "/styles/minimalism-thumb.jpg",
    description: "Minimalism is a clean and powerful art style that celebrates simplicity and essential beauty! This elegant style uses simplified forms, limited color palettes, and clean compositions to focus on what really matters. The art removes unnecessary details, focusing on essential shapes and perfect balance. Minimalism is like painting with pure clarity and purpose!",
    videoUrl: "/videos/minimalism-intro.mp4",
    characteristics: ["Simplified forms","Limited color palette","Clean compositions","Essential shapes","Balance","Reduced details"],
    famousArtists: ["Donald Judd","Agnes Martin","Frank Stella"],
    yearRange: "1960s-present",
    kidFriendlyDescription: "Minimalism is like painting with pure clarity and purpose! Artists use simple shapes and clean lines to create beautiful, focused pictures!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/minimalism/transform"
  },
  {
    id: "opart",
    name: "Op Art",
    thumbnail: "/styles/opart-thumb.jpg",
    description: "Op Art is an exciting and mind-bending art style that plays with your eyes and brain! This fascinating style uses optical patterns, precise geometric shapes, and high-contrast color combinations to create amazing visual illusions. The art makes you see movement and depth where there isn't any, creating a magical optical experience. Op Art is like painting with pure visual magic!",
    videoUrl: "/videos/opart-intro.mp4",
    characteristics: ["Optical patterns","Precise geometric shapes","High-contrast colors","Visual illusions","Movement effects","Depth perception"],
    famousArtists: ["Bridget Riley","Victor Vasarely","Josef Albers"],
    yearRange: "1960s-1970s",
    kidFriendlyDescription: "Op Art is like painting with pure visual magic! Artists use geometric patterns and bright colors to create amazing optical illusions!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/opart/transform"
  },
  {
    id: "destijl",
    name: "De Stijl",
    thumbnail: "/styles/destijl-thumb.jpg",
    description: "De Stijl is a bold and revolutionary art style that celebrates pure abstraction and geometric perfection! This innovative style uses straight lines, right angles, and primary colors with black, white, and grey to create perfectly balanced abstract compositions. The art is all about harmony and order, using the simplest elements to create the most powerful visual impact. De Stijl is like painting with pure geometric harmony!",
    videoUrl: "/videos/destijl-intro.mp4",
    characteristics: ["Straight lines","Right angles","Primary colors","Black white grey","Balanced composition","Abstract forms"],
    famousArtists: ["Piet Mondrian","Theo van Doesburg","Gerrit Rietveld"],
    yearRange: "1917-1931",
    kidFriendlyDescription: "De Stijl is like painting with pure geometric harmony! Artists use straight lines and primary colors to create perfectly balanced abstract pictures!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/destijl/transform"
  },
  {
    id: "romanticism",
    name: "Romanticism",
    thumbnail: "/styles/romanticism-thumb.jpg",
    description: "Romanticism is a passionate and dramatic art style that celebrates emotion and the power of nature! This powerful style uses dramatic lighting, emotional expressions, and nature as a powerful force to convey deep feelings and grand ideas. The art uses dynamic compositions to show passion and grandeur, making everything feel epic and meaningful. Romanticism is like painting with pure emotion and drama!",
    videoUrl: "/videos/romanticism-intro.mp4",
    characteristics: ["Dramatic lighting","Emotional expressions","Nature as powerful force","Dynamic compositions","Passion","Grandeur"],
    famousArtists: ["Eugène Delacroix","Caspar David Friedrich","J.M.W. Turner"],
    yearRange: "1800-1850",
    kidFriendlyDescription: "Romanticism is like painting with pure emotion and drama! Artists use dramatic lighting and powerful nature scenes to create epic, emotional pictures!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/romanticism/transform"
  },
  {
    id: "abstractexpressionism",
    name: "Abstract Expressionism",
    thumbnail: "/styles/abstractexpressionism-thumb.jpg",
    description: "Abstract Expressionism is a wild and energetic art style that celebrates the pure joy of creating! This exciting style uses spontaneous brushwork, layered textures, and gestural marks to show the energy and emotion of the artist. The art focuses on the energy of creation rather than clear forms, making every brushstroke feel alive and powerful. Abstract Expressionism is like painting with pure creative energy!",
    videoUrl: "/videos/abstractexpressionism-intro.mp4",
    characteristics: ["Spontaneous brushwork","Layered textures","Gestural marks","Energy of creation","Abstract forms","Emotional expression"],
    famousArtists: ["Jackson Pollock","Willem de Kooning","Mark Rothko"],
    yearRange: "1940s-1950s",
    kidFriendlyDescription: "Abstract Expressionism is like painting with pure creative energy! Artists use wild brushstrokes and bold colors to show their emotions and energy!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/abstractexpressionism/transform"
  },
  {
    id: "precisionism",
    name: "Precisionism",
    thumbnail: "/styles/precisionism-thumb.jpg",
    description: "Precisionism is a sharp and clean art style that celebrates the beauty of industry and architecture! This precise style uses sharp, clean lines, smooth surfaces, and simplified geometric forms to show the modern world with perfect clarity. The art includes industrial and architectural elements with amazing clarity and order, making everything look crisp and perfect. Precisionism is like painting with pure precision and clarity!",
    videoUrl: "/videos/precisionism-intro.mp4",
    characteristics: ["Sharp clean lines","Smooth surfaces","Simplified geometric forms","Industrial elements","Architectural focus","Clarity and order"],
    famousArtists: ["Charles Sheeler","Charles Demuth","Georgia O'Keeffe"],
    yearRange: "1920s-1940s",
    kidFriendlyDescription: "Precisionism is like painting with pure precision and clarity! Artists use sharp lines and clean shapes to create perfect, modern pictures!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/precisionism/transform"
  },
  {
    id: "neoclassicism",
    name: "Neoclassicism",
    thumbnail: "/styles/neoclassicism-thumb.jpg",
    description: "Neoclassicism is a noble and elegant art style that celebrates the beauty of ancient Greece and Rome! This classical style uses balanced compositions, classical poses, and restrained colors to create timeless beauty. The art makes figures look like ancient sculptures with clear outlines and harmonious proportions, creating a sense of dignity and grace. Neoclassicism is like painting with pure classical beauty!",
    videoUrl: "/videos/neoclassicism-intro.mp4",
    characteristics: ["Balanced compositions","Classical poses","Restrained colors","Ancient sculpture style","Clear outlines","Harmonious proportions"],
    famousArtists: ["Jacques-Louis David","Jean-Auguste-Dominique Ingres","Antonio Canova"],
    yearRange: "1760s-1830s",
    kidFriendlyDescription: "Neoclassicism is like painting with pure classical beauty! Artists use balanced compositions and classical poses to create dignified, elegant pictures!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/neoclassicism/transform"
  },
  {
    id: "symbolism",
    name: "Symbolism",
    thumbnail: "/styles/symbolism-thumb.jpg",
    description: "Symbolism is a mysterious and dreamlike art style that tells stories through hidden meanings! This enchanting style uses dreamlike imagery, muted colors, and allegorical figures to convey deep, hidden messages. The art is filled with symbols and mysterious elements that make you think and wonder about the deeper meaning. Symbolism is like painting with pure mystery and magic!",
    videoUrl: "/videos/symbolism-intro.mp4",
    characteristics: ["Dreamlike imagery","Muted colors","Allegorical figures","Hidden meanings","Symbolic elements","Mysterious atmosphere"],
    famousArtists: ["Gustave Moreau","Odilon Redon","Pierre Puvis de Chavannes"],
    yearRange: "1880s-1910s",
    kidFriendlyDescription: "Symbolism is like painting with pure mystery and magic! Artists use dreamlike images and symbols to tell hidden stories!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/symbolism/transform"
  },
  {
    id: "socialrealism",
    name: "Social Realism",
    thumbnail: "/styles/socialrealism-thumb.jpg",
    description: "Social Realism is a powerful and honest art style that tells the real stories of everyday people! This important style uses detailed, realistic scenes to show everyday life and working-class struggles with truth and dignity. The art uses earthy tones and grounded compositions to capture the real world, making you see and understand the lives of ordinary people. Social Realism is like painting with pure truth and compassion!",
    videoUrl: "/videos/socialrealism-intro.mp4",
    characteristics: ["Detailed realistic scenes","Everyday life","Working-class struggles","Earthy tones","Grounded compositions","Social commentary"],
    famousArtists: ["Diego Rivera","Ben Shahn","Jacob Lawrence"],
    yearRange: "1920s-1950s",
    kidFriendlyDescription: "Social Realism is like painting with pure truth and compassion! Artists show real people and real life with honesty and care!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/socialrealism/transform"
  },
  {
    id: "constructivism",
    name: "Constructivism",
    thumbnail: "/styles/constructivism-thumb.jpg",
    description: "Constructivism is a dynamic and revolutionary art style that celebrates the power of industry and change! This exciting style uses geometric shapes, strong diagonals, and bold contrasts to create a sense of energy and progress. The art feels dynamic and industrial, celebrating the modern world and revolutionary ideas. Constructivism is like painting with pure energy and revolution!",
    videoUrl: "/videos/constructivism-intro.mp4",
    characteristics: ["Geometric shapes","Strong diagonals","Bold contrasts","Dynamic composition","Industrial feel","Revolutionary themes"],
    famousArtists: ["Vladimir Tatlin","Alexander Rodchenko","El Lissitzky"],
    yearRange: "1913-1940s",
    kidFriendlyDescription: "Constructivism is like painting with pure energy and revolution! Artists use bold geometric shapes to show the power of industry and change!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/constructivism/transform"
  },
  {
    id: "suprematism",
    name: "Suprematism",
    thumbnail: "/styles/suprematism-thumb.jpg",
    description: "Suprematism is a pure and abstract art style that celebrates the simplest forms of beauty! This revolutionary style uses simple geometric forms like squares, circles, and lines with a limited palette and strong contrasts. The art focuses on pure abstraction, using only the most basic shapes to create the most powerful visual impact. Suprematism is like painting with pure geometric beauty!",
    videoUrl: "/videos/suprematism-intro.mp4",
    characteristics: ["Simple geometric forms","Squares circles lines","Limited palette","Strong contrasts","Pure abstraction","Basic shapes"],
    famousArtists: ["Kazimir Malevich","Ilya Chashnik","Nikolai Suetin"],
    yearRange: "1915-1930s",
    kidFriendlyDescription: "Suprematism is like painting with pure geometric beauty! Artists use only the simplest shapes to create the most powerful pictures!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/suprematism/transform"
  },
  {
    id: "cubofuturism",
    name: "Cubo-Futurism",
    thumbnail: "/styles/cubofuturism-thumb.jpg",
    description: "Cubo-Futurism is an exciting Russian avant-garde style that combines fractured geometry with dynamic motion! This innovative style uses fractured geometric shapes combined with motion lines to show dynamic movement through layered perspectives. The art feels both geometric and energetic, creating a unique blend of structure and speed. Cubo-Futurism is like painting with pure geometric energy!",
    videoUrl: "/videos/cubofuturism-intro.mp4",
    characteristics: ["Fractured geometric shapes","Motion lines","Dynamic movement","Layered perspectives","Russian avant-garde","Futuristic elements"],
    famousArtists: ["Kazimir Malevich","Natalia Goncharova","Mikhail Larionov"],
    yearRange: "1912-1915",
    kidFriendlyDescription: "Cubo-Futurism is like painting with pure geometric energy! Artists combine broken shapes with motion lines to show speed and movement!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/cubofuturism/transform"
  },
  {
    id: "naiveart",
    name: "Naïve Art",
    thumbnail: "/styles/naiveart-thumb.jpg",
    description: "Naïve Art is a charming and whimsical art style that celebrates childlike wonder and pure joy! This delightful style uses simple shapes, bright colors, and childlike perspectives to create art that feels fresh and innocent. The details can be flat and whimsical without strict proportion, making everything feel playful and free. Naïve Art is like painting with pure joy and innocence!",
    videoUrl: "/videos/naiveart-intro.mp4",
    characteristics: ["Simple shapes","Bright colors","Childlike perspectives","Flat details","Whimsical style","No strict proportion"],
    famousArtists: ["Henri Rousseau","Grandma Moses","Ivan Generalic"],
    yearRange: "19th-20th century",
    kidFriendlyDescription: "Naïve Art is like painting with pure joy and innocence! Artists use simple shapes and bright colors to create playful, childlike pictures!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/naiveart/transform"
  },
  {
    id: "americanregionalism",
    name: "American Regionalism",
    thumbnail: "/styles/americanregionalism-thumb.jpg",
    description: "American Regionalism is a warm and honest art style that celebrates the beauty of rural and small-town American life! This heartfelt style uses realistic depictions of rural life, small-town scenes, and warm natural colors to show the real America. The art uses clear details and American themes to capture the spirit of the heartland. American Regionalism is like painting with pure American spirit!",
    videoUrl: "/videos/americanregionalism-intro.mp4",
    characteristics: ["Realistic depictions","Rural life","Small-town scenes","Warm natural colors","Clear details","American themes"],
    famousArtists: ["Grant Wood","Thomas Hart Benton","John Steuart Curry"],
    yearRange: "1930s-1940s",
    kidFriendlyDescription: "American Regionalism is like painting with pure American spirit! Artists show rural life and small towns with warmth and honesty!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/americanregionalism/transform"
  },
  {
    id: "ashcanschool",
    name: "Ashcan School",
    thumbnail: "/styles/ashcanschool-thumb.jpg",
    description: "Ashcan School is a gritty and honest art style that captures the real energy of city life! This powerful style uses gritty urban scenes painted with loose, expressive brushstrokes to show the truth of the city. The art uses muted tones to capture realism and atmosphere, making you feel like you're right there in the busy streets. Ashcan School is like painting with pure urban truth!",
    videoUrl: "/videos/ashcanschool-intro.mp4",
    characteristics: ["Gritty urban scenes","Loose expressive brushstrokes","Muted tones","Realism","Atmosphere","City life"],
    famousArtists: ["Robert Henri","George Bellows","John Sloan"],
    yearRange: "1908-1920s",
    kidFriendlyDescription: "Ashcan School is like painting with pure urban truth! Artists use loose brushstrokes to capture the real energy and life of the city!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/ashcanschool/transform"
  },
,
  {
    id: "celtic",
    name: "Celtic Art",
    thumbnail: "/styles/celtic-thumb.jpg",
    description: "Celtic Art is a magnificent ancient art style that creates intricate and mystical masterpieces! This style features elaborate knotwork patterns, spiral designs, and stylized animal forms that create symmetrical and decorative compositions. Celtic Art is like weaving magic with lines and shapes, creating beautiful patterns that tell stories of ancient traditions and cultural heritage. The intricate interlacing designs and flowing curves make everything look both elegant and powerful!",
    videoUrl: "/videos/celtic-intro.mp4",
    characteristics: ["Intricate knotwork","Spiral patterns","Stylized animal forms","Symmetrical composition","Decorative elements","Ancient Celtic motifs"],
    famousArtists: ["Unknown Celtic artisans","Ancient Celtic craftsmen","Medieval Celtic artists"],
    yearRange: "500 BCE - 1200 CE",
    kidFriendlyDescription: "Celtic Art is like weaving magic with lines and shapes! Artists create beautiful patterns with intricate knots and spirals that tell stories of ancient traditions!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/celtic/transform"
  },
  {
    id: "persianminiature",
    name: "Persian Miniature",
    thumbnail: "/styles/persianminiature-thumb.jpg",
    description: "Persian Miniature is a breathtaking traditional art style that creates incredibly detailed and colorful masterpieces! This style features fine details, rich colors, and flat perspective that bring stories to life through elaborate patterns and storytelling elements. Persian Miniature art is like painting with pure magic, where every tiny detail tells part of a larger story. The miniature scale and intricate patterns create a world of wonder and beauty that captures the imagination!",
    videoUrl: "/videos/persianminiature-intro.mp4",
    characteristics: ["Fine details","Rich colors","Flat perspective","Elaborate patterns","Storytelling elements","Miniature scale"],
    famousArtists: ["Kamāl ud-Dīn Behzād","Reza Abbasi","Mir Sayyid Ali"],
    yearRange: "13th-17th centuries",
    kidFriendlyDescription: "Persian Miniature is like painting with pure magic! Artists create incredibly detailed pictures with rich colors that tell beautiful stories!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/persianminiature/transform"
  },
  {
    id: "tonalism",
    name: "Tonalism",
    thumbnail: "/styles/tonalism-thumb.jpg",
    description: "Tonalism is a peaceful and atmospheric art style that creates serene and moody masterpieces! This style uses a muted palette with soft brushwork and atmospheric effects to focus on mood through subtle gradations of color. Tonalism is like painting with whispers and dreams, where soft colors and gentle transitions create a sense of tranquility and contemplation. The style emphasizes the emotional quality of light and atmosphere over bright, bold colors!",
    videoUrl: "/videos/tonalism-intro.mp4",
    characteristics: ["Muted palette","Soft brushwork","Atmospheric effects","Subtle gradations","Mood-focused","Tranquil atmosphere"],
    famousArtists: ["George Inness","James McNeill Whistler","Albert Pinkham Ryder"],
    yearRange: "1880s-1920s",
    kidFriendlyDescription: "Tonalism is like painting with whispers and dreams! Artists use soft colors and gentle transitions to create peaceful, moody pictures!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/tonalism/transform"
  },
  {
    id: "artinformel",
    name: "Art Informel",
    thumbnail: "/styles/artinformel-thumb.jpg",
    description: "Art Informel is a dynamic and expressive art style that celebrates spontaneous creativity and raw emotion! This style features spontaneous, abstract forms with textured surfaces and free gestural marks created without pre-planned structure. Art Informel is like painting with pure energy and emotion, where every brushstroke and texture tells a story of the artist's immediate feelings and reactions. The style emphasizes the process of creation and the power of spontaneous expression!",
    videoUrl: "/videos/artinformel-intro.mp4",
    characteristics: ["Spontaneous forms","Abstract composition","Textured surfaces","Free gestural marks","No pre-planned structure","Expressive energy"],
    famousArtists: ["Jean Fautrier","Hans Hartung","Pierre Soulages"],
    yearRange: "1940s-1960s",
    kidFriendlyDescription: "Art Informel is like painting with pure energy and emotion! Artists create spontaneous, expressive pictures with free brushstrokes and textures!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/artinformel/transform"
  },
  {
    id: "chiaroscuro",
    name: "Chiaroscuro",
    thumbnail: "/styles/chiaroscuro-thumb.jpg",
    description: "Chiaroscuro is a dramatic and powerful art technique that creates stunning masterpieces through the contrast of light and dark! This style uses strong contrasts between light and dark to model three-dimensional form, with direct lighting highlighting key areas while leaving others in shadow. Chiaroscuro is like painting with pure light and shadow, creating dramatic, atmospheric scenes that seem to leap off the canvas. The technique brings depth and emotion to every subject through the masterful use of light!",
    videoUrl: "/videos/chiaroscuro-intro.mp4",
    characteristics: ["Strong light-dark contrasts","Three-dimensional modeling","Direct lighting","Dramatic shadows","Highlighted key areas","Atmospheric depth"],
    famousArtists: ["Caravaggio","Rembrandt","Leonardo da Vinci"],
    yearRange: "15th-17th centuries",
    kidFriendlyDescription: "Chiaroscuro is like painting with pure light and shadow! Artists create dramatic pictures using strong contrasts between bright highlights and deep shadows!",
    transformationType: "single-pass",
    passes: 1,
    serviceEndpoint: "/api/chiaroscuro/transform"
  },
];

export const getArtStyleById = (id) => {
  return artStyles.find(style => style.id === id);
};

export const searchArtStyles = (query) => {
  const lowercaseQuery = query.toLowerCase();
  return artStyles.filter(style => 
    style.name.toLowerCase().includes(lowercaseQuery) ||
    style.description.toLowerCase().includes(lowercaseQuery) ||
    style.characteristics.some(char => char.toLowerCase().includes(lowercaseQuery))
  );
}; 